export default __webpack_public_path__ + "static/media/blueCross.0d9f0d62.svg";